import { ResortOverviewTab } from 'api/resort/types';
import { useAnalytics } from 'util/analytics';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { useSanitizedHtmlProps } from 'util/sanitized';
import {
  useCallback, useLayoutEffect, useRef, useState,
} from 'react';
import classNames from 'classnames';
import styles from 'components/resort/ResortDescriptionTabs/styles.module.scss';

const eventMap: Record<ResortOverviewTab, any> = {
  [ResortOverviewTab.insideScoop]: 'Inside Scoop',
  [ResortOverviewTab.terrain]: 'Terrain',
  [ResortOverviewTab.restaurant]: 'Restaurant',
  [ResortOverviewTab.transportation]: 'Transportation',
  [ResortOverviewTab.overview]: 'Overview',
};

export const Description = (
  {
    text,
    tab,
    title,
    isActive,
  }:
  {
    text?: string,
    tab: ResortOverviewTab,
    title: I18nKeyGenerated['common'] | '',
    isActive: boolean
  },
) => {
  const a = useAnalytics();
  const { t } = useOTSTranslation('common');
  const htmlProps = useSanitizedHtmlProps(text || '');
  const div = useRef<HTMLDivElement>(null);
  const [showButton, setShowButton] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<boolean>(false);

  const onOpen = useCallback(() => {
    setExpanded(true);
    a.viewContent({
      content: (`${eventMap[tab]} Read More`) as any,
    });
  }, []);

  useLayoutEffect(() => {
    const onResize = () => {
      if (isActive) {
        if (div.current) {
          setShowButton(div.current.scrollHeight > div.current.clientHeight);
        }
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [isActive]);

  return (
    <>
      {!!title && <h2 className={styles.hidden}>{t(title)}</h2>}
      <div
        {...htmlProps}
        ref={div}
        className={classNames(
          styles.readMoreDescription,
          styles.wrap,
          isActive ? styles.active : styles.inactive,
          expanded ? '' : styles.collapsed,
          (!expanded && showButton) ? styles.gradient : '',
        )}
      />
      {
        !expanded && showButton && (
          <button
            type="button"
            className={classNames(styles.readMore, isActive ? styles.active : styles.inactive)}
            onClick={onOpen}
          >
            {t('resort.overview.readMore')}
          </button>
        )
      }
    </>
  );
};
